<template>
  <div class="login-page">
    <div class="box">
      <div class="left_bg">
        <img src="@/assets/images/left_bg.png" />
      </div>
      <div class="info">
        <div class="content">
          <img class="content-top-img" src="@/assets/images/logo.png" />
          <el-form
            :model="loginInfo"
            :rules="rules"
            ref="loginInfo"
            label-width="0"
            class="pwd-form"
          >
            <el-form-item prop="username">
              <el-input
                class="username-input"
                size="medium"
                v-model.trim="loginInfo.username"
                placeholder="用户名（花名全拼，如张三 zhangsan）"
              />
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                class="password-input"
                size="medium"
                type="password"
                v-model="loginInfo.password"
                placeholder="密码"
                @keyup.13.native="loginBtn"
                @keyup.native="checkCapslock"
              />
              <span v-show="capsTooltip" class="caps-lock">大写已打开</span>
            </el-form-item>
            <el-button
              class="submit-btn"
              type="primary"
              :loading="loginBtnLoading"
              @click="loginBtn"
            >登录</el-button>
          </el-form>
        </div>
        <span class="return-text">
          <a href="https://sysrm.syounggroup.com/user/login">供应商1688登录入口</a>
          <el-button class="el-icon-question" type="text" @click="dialogVisible = true"></el-button>
        </span>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%"
      title="登录帮助"
    >
      <img
        width="100%"
        height="650px"
        src="https://oss.syounggroup.com/static/file/cml-main-service/supplier-login.jpeg"
      />
    </el-dialog>
    <div class="tips">为了获得最佳操作体验，建议您使用谷歌浏览器</div>
  </div>
</template>
<script>
export default {
  data: () => ({
    dialogVisible: false,
    loginInfo: {
      username: '',
      password: '',
    },
    rules: {
      username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
      password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
    },
    loginBtnLoading: false,
    capsTooltip: false,
  }),
  mounted() {
    sessionStorage.setItem('sessionValid', 0);
  },
  methods: {
    checkCapslock(e) {
      const { key } = e;
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z';
    },
    loginBtn() {
      this.$refs.loginInfo.validate(valid => {
        if (valid) {
          // 获取加密密码
          this.loginBtnLoading = true;
          this.loginBtnLoading = true;
            this.$store
              .dispatch('user/login', this.loginInfo)
              .then(() => {
                this.$router.push('/dashboard');
              })
              .catch(error => {
                this.$message.error(error.msg);
              })
              .finally(() => {
                this.loginBtnLoading = false;
              });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scope>
html,
body {
  height: 100%;
}
.login-page {
  height: 100%;
  background: url('../../assets/images/bg.png') no-repeat;
}
.box {
  width: 1014px;
  height: 660px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.06);
  .left_bg {
    float: left;
  }
  .info {
    position: relative;
    float: right;
    width: 644px;
    height: 660px;
  }
  .content {
    position: absolute;
    left: 50%;
    top: 126px;
    transform: translateX(-50%);
    font-size: 0;
    .content-top-img {
      margin-bottom: 40px;
    }
    .pwd-form {
      padding: 0 12px;
    }
    .pwd-form .el-input {
      position: relative;
    }
    .pwd-form .el-input .el-input__inner {
      width: 372px;
      height: 60px;
      line-height: 60px;
      border-radius: 6px;
      border: 1px solid #dbdbdb;
      padding: 0 0 0 46px;
      margin: 0 0 2px 0;
      font-size: 16px;
      font-weight: 400;
      color: #222;
    }
    .pwd-form .el-input .el-input__inner:focus {
      border: 2px solid #AB0033;
    }
    .pwd-form .username-input::before {
      position: absolute;
      left: 15px;
      top: 20px;
      width: 18px;
      height: 18px;
      content: '';
      background: url('../../assets/images/zhanghao.png') no-repeat;
      background-size: 18px 18px;
    }
    .pwd-form .password-input::before {
      position: absolute;
      left: 15px;
      top: 20px;
      width: 18px;
      height: 18px;
      content: '';
      background: url('../../assets/images/password.png') no-repeat;
      background-size: 18px 18px;
    }
    .pwd-form .el-button {
      width: 372px;
      height: 60px;
      background: #AB0033;
      box-shadow: 0px 3px 6px 0px rgba(215, 9, 47, 0.32);
      border-radius: 4px;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 5px;
      margin-bottom: 24px;
    }
    .caps-lock {
      color: #f26921;
      position: absolute;
      left: 1px;
      top: 30px;
      font-size: 12px;
    }
  }
}
.tips {
  position: fixed;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  font-size: 14px;
  font-weight: 400;
  color: #ae9a8e;
  line-height: 20px;
}
.radio-class {
  .el-radio__label {
    font-size: 18px;
  }
  .el-radio__input {
    vertical-align: top;
  }
}
.return-text {
  position: absolute;
  right: 140px;
  bottom: 120px;
  color: #AB0033;
  cursor: pointer;
  padding: 0 1px 0 2px;
  a {
    color: #AB0033;
    margin-right: 5px
  }
  .el-button {
    font-size: 16px;
  }
};
</style>
